import React from 'react'
import { Button, Header, Icon, Modal, Card, Image, Segment } from 'semantic-ui-react'

const ModalDatosInstructor = ({showModal, closeModal, icono, borrar, texto, titulo, modalInstructor}) => (
  <Modal open={showModal} basic size='fullscreen'>
    <Header icon={icono} content={titulo} />
    <Modal.Content>
        <>
        {texto}
        <Card centered>
        <Image  src={modalInstructor.img} wrapped></Image>
        <Card.Content>
          <Card.Header>{modalInstructor.name}</Card.Header>
          <Card.Description>
            {modalInstructor.desc}
          </Card.Description>
        </Card.Content>
        <Card.Content extra>
          <Button color='green' onClick={closeModal} inverted>
             Cerrar
          </Button>
        </Card.Content>
      </Card>
    
  
    </>
    </Modal.Content>
 
  </Modal>
)

export default ModalDatosInstructor;